import { render, staticRenderFns } from "./InternetExplorerNotice.vue?vue&type=template&id=76f84120&"
import script from "./InternetExplorerNotice.vue?vue&type=script&lang=js&"
export * from "./InternetExplorerNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports